import $ from 'jquery';
import SyosGlobalConfig from '../SyosGlobalConfig';
import SyosEvents from '../utils/SyosEvents';
import SyosAjaxError from '../errors/SyosAjaxError';
import { makeCacheKey, getCachedData, cacheData } from './SyosApiCache';


async function invoke(
  syosController,
  endpoint,
  requestData = null,
  method = 'GET',
  cacheable = true,
  dispatchEventWhenComplete = true,
) {
  const options = {
    url: SyosGlobalConfig.api.basePath + endpoint,
    data: requestData,
    type: method,
    timeout: SyosGlobalConfig.api.requestTimeout,
    contentType: 'application/json',
    dataType: 'json',
  };

  if (method === 'POST') { // TODO - confirm if this is a POST thing or a ReserveTempCartSeats thing
    options.data = JSON.stringify(options.data);
  }

  const useCache = cacheable && SyosGlobalConfig.api.useCachedData;

  syosController.emit(SyosEvents.API_REQUEST_STARTED);

  let cacheKey = null;

  if (useCache) {
    cacheKey = makeCacheKey(endpoint, requestData);
    const cachedData = getCachedData(cacheKey);
    if (cachedData) {
      if (dispatchEventWhenComplete) {
        syosController.emit(SyosEvents.API_REQUEST_COMPLETED);
      }
      return cachedData;
    }
  }

  return new Promise((resolve) => {
    $.ajax(options)
      .done((data, status, jqXHR) => {
        if (useCache) {
          cacheData(cacheKey, data);
        }

        if (dispatchEventWhenComplete) {
          syosController.emit(SyosEvents.API_REQUEST_COMPLETED, {
            data,
            status,
            jqXHR,
          });
        }

        resolve(data);
      })
      .fail((jqXHR, reason, status) => {
        const error = new SyosAjaxError(options, jqXHR, reason, status);

        syosController.emit(SyosEvents.API_REQUEST_ERROR, { error });

        throw error;
      });
  });
}


export {
  invoke,
};



// WEBPACK FOOTER //
// ./src/syos/api/SyosApiRequest.js